<template>
  <ForgotPassword />
</template>

<script>
import ForgotPassword from './ForgotPassword.vue'

export default {
  components: { ForgotPassword }
}
</script>
